import ContentsBase from './ContentsBase';
import LegendGSM from '../legend/LegendGSM';
import { formatBaseTime, formatValidTime } from "../../../utils/FPEUtils";
import { WX_ID_GSM } from "../../../store/WeatherContentsState";
import WRAP from 'WRAP-JS';
import TimeController from "../../map/helper/TimeController";
import Gsm from "../../map/layers/Gsm";

class ModelGSM extends ContentsBase {
  static NAME = WX_ID_GSM;
  static GSM_CHANGE_ALL = 'GSM_change_all';
  static GSM_EQV_PT = 'EqvPT';
  static GSM_ISOTACH = 'Isotach';
  static GSM_ISOTHERM = 'Isotherm';
  static GSM_TMINUS_TD = 'TMinusTD';
  static GSM_VWS = 'VWS';
  static GSM_WIND = 'Wind';
  static GSM_ICING_PROB = 'IcingProb';

  static CS_NAME = `CS_${ModelGSM.NAME}`;
  presetId = ModelGSM.CS_NAME;

  prevValidtime;
  contentsVisibleState = {
    EqvPT: true,
    Isotach: true,
    Isotherm: true,
    TMinusTD: true,
    VWS: true,
    Wind: false,
    IcingProb: true
  };
  setRevision;

  constructor(setRevision) {
    super('GSM', 'GSM', 'Model_GSM');
    this.setRevision = setRevision;
    this.timeController = new TimeController(`CS_${WX_ID_GSM}`, {
      crossSection: true,
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg).then(() => {
          if (this.timeController._parent !== null && autoFlg) {
            this.setRevision();
          }
        });
      }
    });
  }

  addObject() {
    return new Promise((resolve, reject) => {
      this.dataHandler = WRAP.DH.addObject(this.dataConfName);
      this.dataHandler.inspect(function (ref) {
        try {
          if (this._validate(ref)) {
            this.dataReference = ref;
            if(this.dataReference.query("timelist").value()) {
              this.parseTimelist();
              this.ready = true;
              this.updated = true;
              resolve();
            }
          } else {
            this.addErrorMessage('Configuration validate error.');
            reject();
          }
        } catch (e) {
          this._error(e);
          reject();
        }
      }.bind(this), false)
    });
  }

  parseTimelist() {
    const fullList = this.dataReference.query("timelist").value();
    this.validtimeList = this._parseTimelist(fullList);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision()
      }
    }
    this.prevValidtime = JSON.parse(JSON.stringify(this.validtimeList));
  }

  getOpt(date, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(date, fpMode);
        return  {
          Model: {
            Basetime: this.shownTime.basetime,
            Element: {
              ...this.contentsVisibleState
            },
            Name: "GSM",
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible()
          }
        }
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: ModelGSM.NAME,
      label: 'GSM',
      component: LegendGSM,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: ModelGSM.NAME,
      label: 'GSM',
      baseTime: this.shownTime ? formatBaseTime(this.shownTime.basetime) : "---",
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
  }

  getTimeControllerInfo() {
    return {
      mapContentsId: WX_ID_GSM,
      timeController: this.timeController
    };
  }

  setContentsSettings(param) {
    Object.keys(param).forEach(k => {
      this.contentsVisibleState[k] = param[k];
    });
  }

  static resolveCsTargetName(targetName) {
    let csTargetName;
    switch(targetName) {
      case Gsm.WIND_ARROW_NAME:
        csTargetName = ModelGSM.GSM_WIND;
        break;
      case Gsm.ISOTACH_CONTOUR_NAME:
        csTargetName = ModelGSM.GSM_ISOTACH;
        break;
      case Gsm.ISOTHERM_CONTOUR_NAME:
        csTargetName = ModelGSM.GSM_ISOTHERM;
        break;
      case Gsm.ICING_PROB_NAME:
        csTargetName = ModelGSM.GSM_ICING_PROB;
        break;
      default:
        csTargetName = targetName;
        break;
    }
    return csTargetName;
  }
}

export default ModelGSM;
